import { MatchingRecord } from '@eluve/utils';

import { FeatureFlagsEnum } from './types';

export const FeatureFlagLookup: MatchingRecord<FeatureFlagsEnum> = {
  BILLING_CODE_EDITING_IS_ADMIN_ONLY: 'BILLING_CODE_EDITING_IS_ADMIN_ONLY',
  BILLING_CODE_PRICES: 'BILLING_CODE_PRICES',
  BILLING_CODES: 'BILLING_CODES',
  BULK_CHART_EXPORT: 'BULK_CHART_EXPORT',
  CAPTURE_LLM_PROMPT: 'CAPTURE_LLM_PROMPT',
  EHR_ONBOARDING: 'EHR_ONBOARDING',
  ELUVE_GPT: 'ELUVE_GPT',
  INSIGHTS: 'INSIGHTS',
  INSIGHTS_CHAT: 'INSIGHTS_CHAT',
  LLM_OUTPUT_DETAILS: 'LLM_OUTPUT_DETAILS',
  LOCAL_FILES_MANAGEMENT: 'LOCAL_FILES_MANAGEMENT',
  LOCATIONS: 'LOCATIONS',
  PATIENTS_VIEW: 'PATIENTS_VIEW',
  PDF_OUTPUT: 'PDF_OUTPUT',
  SESSION_TYPES: 'SESSION_TYPES',
  SHOW_PLAY_DISCLAIMER_OPTION: 'SHOW_PLAY_DISCLAIMER_OPTION',
  APPOINTMENTS_VIEW: 'APPOINTMENTS_VIEW',
  MULTILINGUAL_SUPPORT: 'MULTILINGUAL_SUPPORT',
  AUTO_GENERATE_SOURCE_ARTIFACTS_FOR_APPOINTMENTS:
    'AUTO_GENERATE_SOURCE_ARTIFACTS_FOR_APPOINTMENTS',
  ALLOW_AUDIO_FILE_UPLOAD_FOR_APPOINTMENT:
    'ALLOW_AUDIO_FILE_UPLOAD_FOR_APPOINTMENT',
  MEDICATION: 'MEDICATION',
  USER_GROUPS: 'USER_GROUPS',
  PATIENT_OVERVIEW: 'PATIENT_OVERVIEW',
  USER_INPUT_DIFFERENTIAL_DIAGNOSIS: 'USER_INPUT_DIFFERENTIAL_DIAGNOSIS',
  ALL_PATIENT_ACCESS: 'ALL_PATIENT_ACCESS',
  MANUAL_CHARTING_MODE: 'MANUAL_CHARTING_MODE',
  APPOINTMENT_DETAILS_READONLY: 'APPOINTMENT_DETAILS_READONLY',
  HIDE_ADDITIONAL_NOTES: 'HIDE_ADDITIONAL_NOTES',
  HIDE_NEW_SESSION_BUTTON: 'HIDE_NEW_SESSION_BUTTON',
  APPOINTMENT_TITLE_READONLY: 'APPOINTMENT_TITLE_READONLY',
  CHART_AMENDMENTS: 'CHART_AMENDMENTS',
  SKIP_NOT_STARTED_APPOINTMENT_LAYOUT: 'SKIP_NOT_STARTED_APPOINTMENT_LAYOUT',
  ALLOW_RERUN_TRANSCRIPTION: 'ALLOW_RERUN_TRANSCRIPTION',
  USE_USER_GROUP_BILLING_CODES: 'USE_USER_GROUP_BILLING_CODES',
  INSIGHTS_PATIENT_SITUATION: 'INSIGHTS_PATIENT_SITUATION',
  APPOINTMENT_COMPLAINT_REASON_ENABLED: 'APPOINTMENT_COMPLAINT_REASON_ENABLED',
  ENABLE_SUPERBILL_EMAIL: 'ENABLE_SUPERBILL_EMAIL',
  ENABLE_TRANSCRIPTION_LOW_CONFIDENCE_DIALOGUE:
    'ENABLE_TRANSCRIPTION_LOW_CONFIDENCE_DIALOGUE',
  ORGANIZATION_USER_INVITES: 'ORGANIZATION_USER_INVITES',
  CHUNKED_BATCH_TRANSCRIPTION: 'CHUNKED_BATCH_TRANSCRIPTION',
  TEMPLATE_PUBLISHING: 'TEMPLATE_PUBLISHING',
  RUN_TRANSCRIPTION_EVAL: 'RUN_TRANSCRIPTION_EVAL',
  MEDPLUM: 'MEDPLUM',
  CLINICAL_TASKS: 'CLINICAL_TASKS',
  TEMPLATE_BUNDLE_MANAGEMENT: 'TEMPLATE_BUNDLE_MANAGEMENT',
  PROMPT_TEMPLATE_BILLING_CODES: 'PROMPT_TEMPLATE_BILLING_CODES',
  ENABLE_TENANT_ADMIN_REGENERATE_NOTE: 'ENABLE_TENANT_ADMIN_REGENERATE_NOTE',
  REPORTING_DASHBOARD: 'REPORTING_DASHBOARD',
  NEW_PATIENT_PROFILE: 'NEW_PATIENT_PROFILE',
  NEW_BOOKING_EXPERIENCE: 'NEW_BOOKING_EXPERIENCE',
} as const satisfies MatchingRecord<FeatureFlagsEnum>;
